const route = {
	path: ':codeTemplate/configuration-process/:id',
	name: 'page-configuration-process',
	meta: {
		title: 'Configuración Procesos',
	},
	props: true,
	component: () => import('@/pages/process/configuration-process'),
	children: [
		{
			path: 'assign-integration',
			name: 'page-configuration-process-assign',
			props: true,
			meta: {
				title: 'Asignar Integración',
			},
			component: () => import('@/components/process/page-configuration-process-assign'),
		},
		{
			path: 'assign-category',
			name: 'page-configuration-process-integration-category',
			props: true,
			meta: {
				title: 'Asignar Categoria',
			},
			component: () => import('@/components/process/page-configuration-process-integration-category'),
		},
	],
};

export default route;



// WEBPACK FOOTER //
// ./src/router/configuration-process.js